// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.dado[data-v-5c5a884e]{\r\n    width: 100%;\r\n    height: 15vh;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    flex-direction: column;\n}\n.title span[data-v-5c5a884e]{\r\n    font-size: 14px;\n}\n@media screen and (max-width:1100px){\n.title span[data-v-5c5a884e]{\r\n    font-size: 11px !important;\n}\n}\n@media screen and (max-width:700px){\n.dado[data-v-5c5a884e]{\r\n    padding: 0 .2rem;\n}\n}\r\n", ""]);
// Exports
module.exports = exports;
